import React from "react";
import {
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
  CardContent,
} from "@/components/ui/card";
import { cn } from "@/lib/utils";

type TextCardProps = {
  type: "intro" | "outro";
  title?: string;
  subtitle?: string;
  description?: string;
  alignment?: "center" | "left" | "right";
  gap?: [string, string, string];
};

const TextCard: React.FC<TextCardProps> = ({
  type,
  title = "",
  subtitle = "",
  description = "",
  alignment = "center",
  gap = ["10", "10", "0"],
}) => {
  const getAlignmentClass = (alignment: "center" | "left" | "right") => {
    switch (alignment) {
      case "left":
        return "text-left";
      case "right":
        return "text-right";
      case "center":
      default:
        return "text-center";
    }
  };

  const alignmentClass = getAlignmentClass(alignment);

  return (
    <Card className={cn("border-none bg-white p-4 shadow-none", alignmentClass)}>
      <CardHeader className="p-0">
        {title && (
          <CardTitle
            className={cn(
              "font-regular text-black",
              `pb-${gap[0]}`,
              type === "intro" ? "text-4xl" : "mt-8 text-3xl",
            )}
            aria-label="Title"
            style={{ fontFamily: "'Toyota Type Regular', sans-serif" }}
          >
            {title}
          </CardTitle>
        )}
        {type === "intro" && subtitle && (
          <CardDescription
            className={cn("text-lg text-gray-500", `pb-${gap[1]}`)}
            aria-label="Subtitle"
          >
            {subtitle}
          </CardDescription>
        )}
      </CardHeader>
      {description && (
        <CardContent
          className={cn("p-0 text-base text-black", `pb-${gap[2]}`)}
          aria-label="Description"
        >
          {description}
        </CardContent>
      )}
    </Card>
  );
};

export default TextCard;
